export class SimplePopover {
  init() {
    const openerElems = document.querySelectorAll('.js-open-simple-popover');
    let popoverActive = null;

    window.addEventListener('click', (e) => {
      if (popoverActive) {
        popoverActive.classList.remove('visible');
      }
    });

    if (openerElems && openerElems.length > 0) {
      openerElems.forEach((openerEl) => {
        const nextPopoverEl = openerEl.nextElementSibling;
        openerEl.addEventListener('click', (e) => {
          if (nextPopoverEl && nextPopoverEl.classList.contains('simple-popover')) {
            if (nextPopoverEl.classList.contains('visible')) {
              nextPopoverEl.classList.remove('visible');
            } else {
              if (popoverActive) {
                popoverActive.classList.remove('visible');
              }
              nextPopoverEl.classList.add('visible');
            }
            popoverActive = nextPopoverEl;
          }
          e.stopPropagation();
        });

        if (nextPopoverEl) {
          nextPopoverEl.addEventListener('click', (e) => {
            e.preventDefault();
            nextPopoverEl.classList.remove('visible');
          });
        }
      });
    }
  }
}

